import { alpha } from '@mui/material';

const primaryBase = '#0D3B66';
const secondaryBase = '#164570';

export const primary = {
  main: primaryBase,
  ultralight: alpha(primaryBase, 0.2),
  light: alpha(primaryBase, 0.5),
  dark: alpha(primaryBase, 0.9),
};
export const secondary = {
  main: secondaryBase,
  light: alpha(secondaryBase, 0.5),
  dark: alpha(secondaryBase, 0.9),
};
